<template>
    <div class="bulkCallsVue" id="bulkCallsVue">
        <div v-if="isEmployeeAllowed">
            <div class="o-ndividualArea c-responsive-fixwidth">
                <div class="o-ndividualTable" v-loading="loading">
                    <div class="bulk-table-outer">
                        <div class="c-common-space">
                            <div class="o-subtitleHeading">
                                <label class="o-blue-regular-text">Group by: </label>
                                <span>
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            Start time
                                            <input type="checkbox" id="checkbox" @change="onInputchangeCheckbox" v-model="callsFilter.start">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                </span>
                                <span>
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            End time
                                            <input type="checkbox" nid="checkbox" @change="onInputchangeCheckbox" v-model="callsFilter.end">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                </span>
                                <span>
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            Position
                                            <input type="checkbox" id="checkbox" @change="onInputchangeCheckbox" v-model="callsFilter.position">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div v-if="isNonEmpty">
                        <div class="bulk-table-outer" v-for="(dateWiseCalls, key, index) in calls" :key="key">
                            <div class="c-common-space o-individual-calls">

                                <div class="col-md-12 o-no-padding">

                                    <h5 :id="'element'+index" class="h5 o-inline">
                                        <div class="calls-table-cell" style="display:inline-block; vertical-align:middle;">
                                            <div class="o-no-padding">
                                            <div class="calls-table-cell-inner-table">
                                                <div class="checkbox o-custom-radio">
                                                <label>
                                                    <input 
                                                    :id="`group-${key}`" 
                                                    @change="handleGroupChange(key, $event.target.checked)"
                                                    type="checkbox" 
                                                    :checked="groupAutofills[key]"
                                                    >
                                                    <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                </label>
                                                </div>
                                            </div>
                                            </div> 
                                        </div>
                                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                                        {{getDate(key)}}
                                    </h5>
                                    
                                    <a :class="{'isDisabled':!getPower('cloneCall')}" href="javascript: void(0)" @click="openCloneModal(key)" class="c-common-btn c-common-btn--small"><i class="fa fa-files-o" aria-hidden="true"></i> Clone</a>
                                    <a :class="{'isDisabled':!getPower('cloneCall')}" href="javascript: void(0)" @click="openAdvanceClone(key)" class="c-common-btn c-common-btn--small"><i class="fa fa-files-o" aria-hidden="true"></i> Advance Clone</a>
                                    <a :class="{'isDisabled':!getPower('deleteCall')}" href="javascript: void(0)" @click="deleteCallsByDate(dateWiseCalls)" class="c-common-btn c-common-btn--small"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete</a>

                                    <div class="o-customSelect o-custom-dropdown o-inline-block margin-left-md">
                                        <label>Jump to day:</label>
                                        <select @change="onSelectScrollTo($event)" v-model="selectedScrollDate" class="form-control">
                                            <option v-for="(call, key, index) in calls" :key="key" v-if="call.length>0" :value="'#element'+index" >{{getDateScrollTO(key)}}</option>
                                        </select>
                                        <span class="o-custom-drop-arrow"><i aria-hidden="true" class="fa fa-angle-down"></i></span>
                                    </div>
                            
                                    <div class="o-customSelect o-custom-dropdown o-inline-block margin-left-md">
                                        <label>Sort by:</label>
                                        <select v-model="selectedSortType" class="form-control" @change="changeSortType">
                                            <option value="start">Start time</option>
                                            <option value="skill">Skill</option>
                                            <option value="status">Unassigned</option>
                                            <option value="seniority">Seniority</option>
                                        </select>
                                        <span class="o-custom-drop-arrow"><i aria-hidden="true" class="fa fa-angle-down"></i></span>
                                    </div>

                                    <!-- #1049 — Call Sheet Notify: the day's master icon (whole day; every group unselected) -->
                                    <div class="custom-col text-right float-right" v-if="notifyAllowed">
                                        <el-tooltip content="Notify this day" placement="top" effect="dark">
                                            <a href="javascript: void(0)" @click="openNotify(key, 'day')" class="c-common-btn c-common-btn--small csn-icon csn-icon--day"
                                               :data-testid="'csn-day-' + key"><i class="fa fa-mobile fa-lg" aria-hidden="true"></i></a>
                                        </el-tooltip>
                                    </div>
                                    <div class="custom-col text-right float-right">
                                        <a  href="javascript: void(0)" v-if="getPower('addCall') || addCallPower()" @click="addBulkCall(key)" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Calls</a>
                                    </div>
                                </div>
                            </div>

                            <table class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 payroll-viewcall-table-align overflow-show">
                                <thead>
                                    <tr>
                                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">AF</span></th>
                                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">Start time:</span></th>
                                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 table-td-border-right"><span class="o-no-margin-bottom">End time:</span></th>
                                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">Position</span></th>
                                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 table-td-border-right"><span class="o-no-margin-bottom">Employee</span></th>
                                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 table-td-border-right"><span class="o-no-margin-bottom">Rate/hr</span></th>
                                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10  text-center table-td-border-right">
                                            <el-tooltip class="item" effect="dark" content="Assigned/Unassigned" placement="top-end">
                                                <span class="o-no-margin-bottom">A/U</span>
                                            </el-tooltip>
                                        </th>
                                        <th align="center" valign="top" class="o-accordion-subtext text-center u-cmn-padding10"><span class="o-no-margin-bottom">Notes:</span></th>
                                        <th align="left" valign="top" class="o-accordion-subtext table-td-border-right text-center"><span class="o-no-margin-bottom">Assign</span></th>
                                        <th align="center" valign="top" class="o-accordion-subtext"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(call, id) in dateWiseCalls" :key="id">

                                        <td align="left" valign="top" class="table-td-border-top">
                                            <div class="">
                                                <div class="o-no-padding">
                                                    <div class="">
                                                        <div class="checkbox">
                                                            <label>
                                                                <!-- <input 
                                                                    @change="handleIndividualChange(call)" 
                                                                    type="checkbox" 
                                                                    v-model="call.af"
                                                                > -->

                                                                <input 
                                                                    :id="`group-${key}-${id}`"
                                                                    :checked="groupCheckboxStates[`${key}-${id}`] && groupCheckboxStates[`${key}-${id}`].checked"
                                                                    :indeterminate="groupCheckboxStates[`${key}-${id}`] && groupCheckboxStates[`${key}-${id}`].indeterminate"
                                                                    @change="handleIndividualChange($event, key, call, id)"
                                                                    type="checkbox"
                                                                />

                                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>


                                        <td :id="'backTo'+index+id" align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5">
                                            <p v-if="callsFilter.start">{{getTime(call.start)}}</p>
                                            <p v-else v-for="(singleCall, inxd) in call.call" :key="inxd">{{getTime(singleCall.start)}}</p>
                                        </td>
                                        <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 table-td-border-right">
                                            <p v-if="callsFilter.end">{{getTime(call.end)}}</p>
                                            <p  v-else v-for="(singleCall, inxd) in call.call" :key="inxd">{{getTime(singleCall.end)}}</p>
                                        </td>
                                        <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5">
                                            <p v-if="callsFilter.position">{{call.skills[0].name}}({{call.skills[0].priotiy}})</p>
                                            <p v-else v-for="(skill, inxd) in call.skills" :key="inxd">{{skill.name}}({{skill.priotiy}})</p>
                                        </td>
                                        <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 table-td-border-right">
                                            <p v-for="(singleCall, inxd) in call.call" v-if="singleCall && singleCall.employee" :key="inxd" :class="{'text-danger':singleCall.employee.deleted_at}">
                                                <span v-if="singleCall.employee&&singleCall.employee.employable">
                                                    <span v-if="empSort=='fname_desc'">
                                                        {{singleCall.employee.employable.last_name +", "+singleCall.employee.employable.first_name+(singleCall.employee.seniority?"("+ getRoundOffSkillSeniority(singleCall.employee.seniority) +")":'')}}
                                                    </span>
                                                    <span v-else>
                                                        {{singleCall.employee.employable.first_name +" "+singleCall.employee.employable.last_name+(singleCall.employee.seniority?"("+ getRoundOffSkillSeniority(singleCall.employee.seniority) +")":'')}}
                                                    </span>
                                                    <el-tooltip class="item" effect="dark" content="Confirmed" placement="top-end">
                                                        <i v-if="singleCall.status&&singleCall.status.name&&singleCall.status.name=='Confirmed'" class="fa fa-check confirm-check-icon-style" aria-hidden="true"></i>
                                                    </el-tooltip>
                                                </span>
                                            </p>
                                        </td>

                                        <td align="center" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 table-td-border-right text-center">
                                            {{  call.rate ? '$ ' + call.rate : ''  }}
                                        </td>

                                        <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5  text-center table-td-border-right">
                                            <p>{{call.assigned}}/<span :class="{'unassigned-calls-number': call.unassigned }" >{{call.unassigned}} </span></p>
                                        </td>
                                        <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 text-center">
                                            <p v-if="noteBtnActive(call)" >
                                                <a @click="goToViewEmployee(call)" href="javascript: void(0)" class="c-common-btn c-common-btn--xsmall c-common-btn--inverse-icon-green c-common-btn-min-width">
                                                    <i data-v-d8a8ddae="" aria-hidden="true" class="fa fa-eye"></i> View Notes
                                                </a>
                                            </p>
                                            <p v-else>- - -</p>
                                        </td>
                                        <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 text-center table-td-border-right">
                                            <p>
                                                <a :class="{'disabled':!callsFilter.start || !callsFilter.end || !callsFilter.position}" @click="bulkAssign(call, 'backTo'+index+id)" href="javascript: void(0)" class="c-common-btn c-common-btn--xsmall c-common-btn--inverse-icon-green c-common-btn-min-width">
                                                    <i data-v-d8a8ddae="" aria-hidden="true" class="fa fa-plus-circle"></i> Bulk Assign
                                                </a>
                                            </p>
                                        </td>
                                        <td align="center" valign="top" class="o-table-block-btn table-td-border-top u-cmn-padding5">
                                            <div class="fontsize-0">
                                                <el-tooltip v-if="notifyAllowed" content="Notify" placement="top" effect="dark"><a @click="openNotify(key, 'item', id)" href="javascript: void(0)" class="float-none edit-del csn-icon" :data-testid="'csn-row-' + key + '-' + id"><i aria-hidden="true" class="fa fa-mobile"></i></a></el-tooltip>
                                                <a @click="editBulk(call)" :class="{'disabled':!getPower('editCall')}" href="javascript: void(0)" class="float-none edit-del"><i data-v-d8a8ddae="" aria-hidden="true" class="fa fa-pencil"></i></a>
                                                <a @click="deleteBulkCall(call)" :class="{'disabled':!getPower('deleteCall')}" href="javascript: void(0)" class="float-none edit-del"><i data-v-d8a8ddae="" aria-hidden="true" class="fa fa-trash-o"></i></a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div v-else class="c-common-gradient c-common-box-shadow c-radius3">
                        <div class="col-md-12 no-job-dispaly">
                            <i class="fa fa-frown-o" aria-hidden="true"></i>
                            <br />
                            No Data Stored
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <NotAllowed />
        </div>

        <!-- #1049 — one popup per view; it also reports whether notify is switched on for this client -->
        <call-sheet-notify ref="notify" @allowed="notifyAllowed = $event" @sent="onNotified" />
        <modal name="edit-bulk"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div id="" class="modal-add-call" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="closeEditBulk()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                            <h1 class="modal-title">Edit Bulk</h1>
                        </div>
                        <div class="c-common-box-shadow c-bg-white o-margin-top15">
                        <div class="row">
                            <div class="col-md-12 ">
                                <h1 class="o-modal-head">Current grouping parameters:</h1>
                            </div>
                            <div class="col-md-12">
                                <div class="o-modal-doc-cont">
                                    <ul class="o-documents-container o-documents-container--modal o-bulk-edit-list">
                                        <li v-if="callsFilter.start">
                                            <div class="col-md-12 o-no-padding o-bulk-edit-list-item">
                                                <span>Start Time:</span> {{getGlobalDate(editBulkcall.startDate) +" "+ editBulkcall.startTime}}
                                            </div>
                                        </li>
                                        <li v-if="callsFilter.end">
                                            <div class="col-md-12 o-no-padding o-bulk-edit-list-item">
                                                <span>End Time:</span> {{getGlobalDate(editBulkcall.endDate)+" "+ editBulkcall.endTime}}
                                            </div>
                                        </li>
                                        <li v-if="callsFilter.position">
                                            <div class="col-md-12 o-no-padding o-bulk-edit-list-item">
                                                <span>Position:</span> {{editBulkcall.skillName}}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body">

                        <div v-if="callsFilter.start" class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Start Time:</label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <label class="common-label-input--modalwidth o-custom-dropdown">

                                <date-picker name="Start" v-validate="{required: true}" v-model="editBulkcall.startTime" :config="config" placeholder="Select Time"></date-picker>
                                <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        
                        <div v-if="callsFilter.end" class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">End Time:</label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <label class="common-label-input--modalwidth o-custom-dropdown">
                                <date-picker name="End" v-validate="{required: true}" v-model="editBulkcall.endTime" :config="config" placeholder="Select Time"></date-picker>
                                <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        
                        <div v-if="callsFilter.position" class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Position:</label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">

                                <div class="o-cutsomSelect">
                                    <select v-model="editBulkcall.skill" class="form-control">
                                            <option value="">---- Select Position ----</option>
                                        <option v-for="(position,positionIndex) in positions" :key="positionIndex" :value="position.id">{{position.name}}</option>
                                    </select>
                                </div>

                                </div>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Rate(<span v-html="getCurrencyIcon()"></span>)</label>
                                    <label class="common-label-text">Keep:</label>
                                    <el-switch
                                        style="display: inline"
                                        v-model="editBulkcall.keep_rates"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value="true"
                                        :inactive-value="false">
                                    </el-switch>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <div>
                                        <input type="number" v-model="editBulkcall.rate" :disabled="editBulkcall.keep_rates" class="form-control" :placeholder="getCurrencyUpper()">
                                </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Notes</label>
                                    <label class="common-label-text">Keep:</label>
                                    <el-switch
                                        style="display: inline"
                                        v-model="editBulkcall.keep_notes"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value="true"
                                        :inactive-value="false">
                                    </el-switch>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                    <div>
                                        <textarea @keydown="isNoteChanged = true;" :disabled="editBulkcall.keep_notes"  type="textarea" v-model="editBulkcall.notes" class="form-control"></textarea>
                                </div>
                                </div>
                            </div>
                        </div>

                        <!-- #2017 — "Calls in group". ▲ adds calls with this group's position and times;
                             ▼ only takes back calls added in this edit. Never below the opening count:
                             the ▼ stops there and a typed value below it snaps back. The server
                             enforces the same floor. -->
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Calls in group:</label>
                                </div>
                                <div class="col-sm-9 o-left-no-padding o-modal-form-field cig">
                                    <button type="button" class="btn btn-default btn-sm cig__btn" aria-label="Fewer calls"
                                            :disabled="callsInGroup.value <= callsInGroup.floor"
                                            @click="stepCallsInGroup(-1)" data-testid="calls-in-group-down">&#9660;</button>
                                    <input type="number" class="form-control cig__input" :min="callsInGroup.floor" step="1"
                                           v-model.number="callsInGroup.value" @change="clampCallsInGroupInput"
                                           data-testid="calls-in-group" />
                                    <button type="button" class="btn btn-default btn-sm cig__btn" aria-label="More calls"
                                            @click="stepCallsInGroup(1)" data-testid="calls-in-group-up">&#9650;</button>
                                    <small class="cig__hint" data-testid="calls-in-group-hint">
                                        Minimum {{ callsInGroup.floor }} (the group's size now).
                                        <span v-if="callsInGroup.value > callsInGroup.floor">+{{ callsInGroup.value - callsInGroup.floor }} added on Save.</span>
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <span class="col-sm-6 o-right-no-padding o-modal-form-field allign-right">
                                    <label class="common-label-text common-label-text--modalwidth">Keep Confirmations:</label>
                                </span>
                                <el-switch
                                    style="display: inline"
                                    v-model="editBulkcall.keep_confirmation"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6"
                                    :active-value="1"
                                    :inactive-value="0">
                                </el-switch>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="closeEditBulk()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="saveEditCall()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-save"></i> Save</a>
                            </li>
                        </ul>
                    </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="call-clone"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div id="" class="modal-add-call" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="closeCloneModal()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                            <h1 class="modal-title">Basic Bulk Clone</h1>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <h2 class="h2 text-center">{{selectedJobTitle}}</h2>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <hr class="o-modal-separetor" />
                                        </div>
                                    </div>
                                    <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                        <p class="ps2">This routine will duplicate all calls from the source date to another day within the same job. All calls already existing in that day will be deleted, so this tool should be used before adding additional calls that are not sourced from the original date.</p>
                                        <p class="ps2">To clone days to a date outside of the job's scope, it will be necessary to edit the job and extend the end date, otherwise the date will not appear in the dropdown box.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <hr class="o-modal-separetor" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group ">
                                        <label class="common-label-text">Clone
                                            <br />calls from:</label>
                                        <label class="common-label-input">
                                            {{getGlobalDate(cloneData.cloneFrom)}}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group ">
                                        <label class="common-label-text">Clone
                                            <br />calls to:</label>
                                        <label class="common-label-input">
                                            <select class="form-control" v-model="cloneData.closeTo">
                                                <option v-for="(callDay, key) in callDaysForJob" :key="key" :value="callDay.date">{{getGlobalDate(callDay.date)}}</option>
                                            </select>
                                        </label>
                                    </div>
                                </div>


                                <div class="col-sm-12">
                                    <div class="form-group ">
                                        <label class="common-label-text">Copy assignments?</label>
                                        <div class="checkbox o-custom-radio">
                                            <label>
                                                <input type="checkbox" id="checkbox" v-model="cloneData.assignments">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="closeCloneModal()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="cloneCall()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Calls</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="advance-call-clone"  height="auto" width="1000px" :scrollable="true" class="modal-dialog modal-lg o-large-modal">
            <div id="" tabindex="-1" role="dialog">
                <div role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="closeAdvanceClone()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                            <h1 class="modal-title">Advance Bulk Clone Call</h1>
                        </div>
                        <div class="c-common-box-shadow o-modal-body c-margin-bottom-10">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group o-no-margin">
                                        <label class="common-label-text">Clone From:</label>
                                        <label class="common-label-input">
                                        <div class="o-cutsomSelect">
                                            <select class="form-control" v-model="advanceCloneData.callUnderSelectedDay">
                                                <option v-for="(callDay, key) in callDaysForJob" :key="key" :value="callDay.calls" v-if="(callDay.calls.length>0)? true : false" v-bind:selected="key === 0">{{getGlobalDate(callDay.date)}}</option>
                                            </select>
                                        </div>
                                        </label>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group o-no-margin">
                                        <label class="common-label-text">Insert Mode:</label>
                                        <label class="common-label-input">
                                            <div class="o-cutsomSelect">
                                                <select class="form-control" v-model="advanceCloneData.insertMode">
                                                    <option value="1">Merge calls into existing calls</option>
                                                    <option value="0">Replace all existing calls</option>
                                                </select>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                          <div class="col-12 col-md-6">
                              <div class="c-common-box-shadow c-bg-white c-margin-bottom-10">
                                  <div class="row">
                                      <div class="col-md-12">
                                          <div class="call-clone-table o-table-overflow-large">
                                              <div class="call-clone-table-head">
                                                  <h4 class="ps1">Clone From</h4>
                                                  <div class="o-floar-right">
                                                      <h4 class="ps2 o-blue-medium-text">   :</h4>
                                                      <a href="javascript: void(0)" @click="selectAllCall()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilter == 'all')?'o-filter-active':''">All</a>
                                                      <a href="javascript: void(0)" @click="selectNoneAllCall()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilter == 'none')?'o-filter-active':''">None</a>
                                                  </div>

                                              </div>
                                              <div class="call-clone-table-body">
                                                  <div class="call-clone-table-body-tr">
                                                      <div class="call-clone-table-body-tr-td">
                                                          &nbsp;
                                                      </div>
                                                      <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                          Start time
                                                      </div>
                                                      <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                          End time
                                                      </div>
                                                      <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                          Skill
                                                      </div>
                                                      <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                          Employee
                                                      </div>
                                                  </div>
                                                  <div v-for="(call,callsIndex) in advanceCloneData.callUnderSelectedDay" :key="callsIndex" class="call-clone-table-body-tr">
                                                      <div class="call-clone-table-body-tr-td">
                                                          <div class="checkbox o-custom-radio">
                                                              <label>
                                                                  <input type="checkbox" name="o4" :value="call.id" v-model="advanceCloneData.selectedcallsToClone">
                                                                  <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                              </label>
                                                          </div>
                                                      </div>
                                                      <div class="call-clone-table-body-tr-td">
                                                          {{getTime(call.start)}}
                                                      </div>
                                                      <div class="call-clone-table-body-tr-td">
                                                          {{getTime(call.end)}}
                                                      </div>
                                                      <div class="call-clone-table-body-tr-td">
                                                          {{call.skill.name}}
                                                      </div>
                                                      <div class="call-clone-table-body-tr-td">
                                                          {{(call.employee != null)?call.employee.employable.first_name + " " + call.employee.employable.last_name:"Not Assign"}}
                                                      </div>
                                                  </div>

                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="col-12 col-md-6">
                              <div class="c-common-box-shadow c-bg-white c-margin-bottom-5">
                                  <div class="row">
                                      <div class="col-sm-12">
                                          <div class="call-clone-table-head">
                                              <div class="form-group o-no-margin">
                                                  <label class="common-label-text common-label-text--fullwidth">Assignments:</label>
                                                  <label class="common-label-input--fullwidth o-custom-dropdown">
                                                      <select class="form-control" v-model="advanceCloneData.assignments">
                                                          <option value="1">Preserve call assignments</option>
                                                          <option value="0">Clear call assignments</option>
                                                      </select>
                                                      <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                  </label>
                                              </div>
                                          </div>
                                      </div>
                                      <div class="col-sm-12">
                                          <div class="call-clone-table-head">
                                              <hr class="o-common-separetor o-no-margin" />
                                          </div>
                                      </div>
                                      <div class="col-md-12">
                                          <div class="call-clone-table o-table-overflow-large">
                                              <div class="call-clone-table-head">
                                                  <div class="o-floar-left clone-to-box-inline" style="width: 65%; display: inline-block;">
                                                      <h4 class="ps2 o-blue-medium-text">Clone To:</h4>
                                                      <select class="form-control clone-to-select-box" v-model="advanceCloneData.selectedCloneToJob" @change="getJobCalls()" style="width: 70%; display: inline-block;">
                                                          <option v-for="(job,jobIndex) in avdCloneJob" :key="jobIndex" :value="job.id">{{job.title}}</option>

                                                      </select>
                                                  </div>
                                                  <div class="o-floar-right">
                                                      <h4 class="ps2 o-blue-medium-text">Select:</h4>
                                                      <a href="javascript: void(0)" @click="selectAllDay()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilterDay == 'allDay')?'o-filter-active':''">All</a>
                                                      <a href="javascript: void(0)" @click="selectNoneAllDay()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilterDay == 'noneDay')?'o-filter-active':''">None</a>
                                                  </div>

                                              </div>
                                              <div class="call-clone-table-body">
                                                  <div class="call-clone-table-body-tr">
                                                      <div class="call-clone-table-body-tr-td">
                                                          &nbsp;
                                                      </div>
                                                      <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                          Date
                                                      </div>
                                                      <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                          Calls
                                                      </div>

                                                  </div>
                                                  <div v-for="(dayCall,dayCallIndex) in avdCloneCall" :key="dayCallIndex" class="call-clone-table-body-tr">
                                                      <div class="call-clone-table-body-tr-td">
                                                          <div class="checkbox o-custom-radio">
                                                              <label>
                                                                  <input type="checkbox" name="o4" :value="dayCall.date" v-model="advanceCloneData.selectedDaysToClone">
                                                                  <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                              </label>
                                                          </div>
                                                      </div>
                                                      <div class="call-clone-table-body-tr-td">
                                                          {{getGlobalDate(dayCall.date)}}
                                                      </div>
                                                      <div class="call-clone-table-body-tr-td">
                                                          {{dayCall.calls}} calls
                                                      </div>
                                                  </div>


                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                        </div>

                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="closeAdvanceClone()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="saveAdvanceClone()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Clone Calls</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="viewEmployee"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div id="" tabindex="-1" role="dialog">
                <div role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="closeViewEmployee()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                            <h1 class="modal-title">Call Notes</h1>
                        </div>

                        <div class="c-common-box-shadow c-bg-white c-margin-bottom-5 c-margin-top-5">
                            <div class="row">

                                <div class="col-md-12">
                                    <div class="call-clone-table o-table-overflow-large">
                                        <div class="o-modal-empList">

                                            <div v-for="(call, indx) in viewEmpList" :key="indx" class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 empModal-table-align">
                                                <div class="calls-table-row">
                                                    <div class="calls-table-cell">
                                                        <div class="table-td-border-right">
                                                            <div class="o-accordion-subtext o-rowtable-text">

                                                                <div><span>Call:</span>
                                                                    {{
                                                                        getTime(call.start)+' to '+getTime(call.end)
                                                                    }}
                                                                </div>
                                                                <div><span>Employee:</span>
                                                                    {{
                                                                        (call.employee)?' '+ call.employee.employable.first_name + " " + call.employee.employable.last_name:' - - -'
                                                                    }}

                                                                </div>
                                                                <div><span>Notes: </span>{{ call.notes && call.notes.length>0?' '+ call.notes:' - - -' }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="modal-footer text-center">
        
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="clone-conflict-employee-modal"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
          <div id="" class="modal-add-call" tabindex="-1" role="dialog">
             <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center modal-header--heading">
                        <button @click="closeCloneConflictEmployeeModal()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                        <h1 class="modal-title">
                            Clone Assignment Conflict
                            <el-tooltip class="item" effect="dark" content="Click to Copy Job Data" placement="top-start">
                                <a @click.stop="copyText()" class="o-job-copy-icon"><i class="fa fa-paste"></i></a>
                            </el-tooltip>
                        </h1>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                    <div class="ps2">
                                        Following employees will not get assignments due to conflicts.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <hr class="o-modal-separetor" />
                            </div>
                        </div>
                        <div v-for="(emp,index) in cloneConflictEmployees" :key="index">
                            <p class="ps2">
                                {{ index+1 +'. ' + emp.emp_name }} has a conflict because of
                                <span v-if="emp.conflict_type=='Recurring Unavailability'" class="text-danger">
                                    Recurring Unavailability
                                </span>
                                <span v-else-if="emp.conflict_type=='Vacation' && emp.job_no==''" class="text-warning">
                                    Vacation
                                </span>
                                <span v-else-if="emp.conflict_type=='booking' && emp.job_no!=''" class="text-primary">
                                    {{ emp.job_title + ' - (' + emp.job_no + ')' }}
                                </span>
                                <span v-else class="text-info">{{ emp.conflict_type }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <vue-json-to-csv :json-data="cloneConflictEmployees"
                                    :labels="{
                                        emp_name: { title: 'Name' },
                                        date: { title: 'Date' },
                                        conflict_type: { title: 'Conflict'},
                                        job_title: { title: 'Job Name' },
                                        job_no: { title: 'Job Number' },
                                    }"
                                    @success="val => handleCsvSuccess(val)"
                                    @error="val => handleCsvError(val)"
                                    csv-title="Clone-Conflict-Employee"
                                    >
                                    <el-tooltip class="item" effect="dark" content="Click to Download CSV" placement="top-start">
                                        <a href="javascript: void(0)"  class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue">Download To CSV <i class="fa fa-arrow-circle-o-down"></i></a>
                                    </el-tooltip>
                                </vue-json-to-csv>
                            </li>

                            <li>
                                <a href="javascript: void(0)" @click="closeCloneConflictEmployeeModal()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"> Close </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
          </div>
        </modal>
    </div>
</template>

<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    // #1854 — prewarm the assign caches for this job. Fire-and-forget:
    // never awaited, scheduled off the critical path, failures swallowed.
    import { warmJobCache } from '../../warmAssignCache.js';
    import { clampCallsInGroup, callsToAdd } from '../../callsInGroup';
    import {
        bus
    } from '../../main';
    import {
        scroller
    } from 'vue-scrollto/src/scrollTo';
    import VueJsonToCsv from 'vue-json-to-csv';
    import NotAllowed from '@/components/NotAllowed';
    import CallSheetNotify from './callSheetNotify.vue';   // #1049

    export default {
        data() {
            const dataProps = {
                auto_fill: 0,
                groupAutofills: {},
                groupStates: {},
                datewiseCheckboxStates: {},
                isEmployeeAllowed: true,
                apiCallCount: 0,
                empSort: 'fname_asc',
                notifyAllowed: false,   // #1049 — set by <call-sheet-notify> from the client's batch_notify_flag
                selectedScrollDate: "",
                polling: null,
                timerState: "uninit",
                selectedFilter: 'none',
                selectedFilterDay: 'noneDay',
                viewEmpList: [],
                selectedSortType: 'start',
                editBulkcall: {
                    keep_confirmation: 0,
                    keep_notes: 0,
                    keep_rates: 0,
                    startDate: '',
                    startTime: '',
                    endDate: '',
                    endTime: '',
                    skill: '',
                    skillName: '',
                    notes: '',
                    rate:''
                },
                config: {
                    format: 'h:mm A',
                    useCurrent: false,
                    showClear: false,
                    showClose: false,
                    widgetPositioning: {
                        //vertical: 'top',
                        horizontal: 'right'
                    },
                    parseInputDate: (inputDate) => {
                        if (typeof inputDate === 'string') {
                        const match = inputDate.match(/^(\d{1,2})(\d{2})?$/);
                            if (match) {
                                let hours = parseInt(match[1], 10);
                                let minutes = match[2] ? parseInt(match[2], 10) : 0;
                                return moment({ hour: hours, minute: minutes });
                            }
                        }
                        return moment(inputDate, 'hh:mm A');
                    },
                },
                afterAPI: false,
                calls:[],
                callsFilter: {
                    start: true,
                    end: true,
                    position: true
                },
                loading: false,
                positions: [],
                callDaysForJob: [],
                callIds: [],
                // #2017 — floor = the group's size when the edit opened; value = what Save sends
                callsInGroup: { floor: 0, value: 0 },
                cloneData: {
                    assignments: true,
                    cloneFrom: '',
                    closeTo: '',
                },
                pickerOptions: {
                    disabledDate(time) {
                        return (time.getTime() < dataProps.getDates().jobStart || time.getTime() > dataProps.getDates().jobEnd);
                    }
                },
                advanceCloneData: {
                    selectedDaysToClone: [],
                    selectedcallsToClone: [],
                    insertMode: 1,
                    assignments: 1,
                    selectedCloneToJob:'',
                    callUnderSelectedDay: [],
                },
                avdCloneJob:[],
                avdCloneCall:[],
                selectedJobTitle:'',
                isNoteChanged:false,
                cloneConflictEmployees: []
            };
            return dataProps;
        },

        props: {
            sortType: {
                type: String,
                required: true
            },
            job:{
                type: Object,
                required: true
            }
        },

        watch: {
            sortType: function(newData) {
                this.selectedSortType = newData;
                this.sortCalls();
            },

            job: function(data){
                this.selectedJobTitle = this.job?this.job.title:'';
            },
            getSelectedCallList() {
                if(this.getSelectedCallList === 'bulk') {
                    this.getBulkCalls();
                }
            }

        },

        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                jobId: 'selectedJobId',
                userID: 'userID',
                getLastPositionId: 'getLastPositionId',
                getCurrency: 'getCurrency',
                getSelectedCallList: 'getSelectedCallList'
            }),
            isIdle() {
                return this.$store.state.idleVue.isIdle;
            },
            isNonEmpty() {
                if (Array.isArray(this.calls)) {
                    return this.calls.length > 0;
                } else if (this.calls && typeof this.calls === 'object') {
                    return Object.keys(this.calls).length > 0;
                }
                return false;
            },
            groupCheckboxStates() {
                const states = {};
                Object.keys(this.calls || {}).forEach(dateKey => {
                    const dateGroups = this.calls[dateKey] || [];
                    dateGroups.forEach((group, groupIndex) => {
                        const groupKey = `${dateKey}-${groupIndex}`;
                        if (group.call && Array.isArray(group.call)) {
                            const totalCalls = group.call.length;
                            const checkedCalls = group.call.filter(call => call.af).length;
                            states[groupKey] = {
                                checked: checkedCalls === totalCalls && totalCalls > 0,
                                indeterminate: checkedCalls > 0 && checkedCalls < totalCalls,
                                total: totalCalls
                            };
                        } else {
                            states[groupKey] = { checked: false, indeterminate: false, total: 0 };
                        }
                    });
                });
                return states;
            }
        },

        methods: {
            checkNotifyGroup() {
                console.log("CheckGroup");
            },
            checkNotifySingle() {
                console.log("CheckSingle");
            },
            // #1049 — Call Sheet Notify. The popup decides who (confirmed only) and sends
            // through the phone sheet's endpoints; this just hands it the day.
            openNotify(key, type, index) {
                if (!this.$refs.notify) return;
                this.$refs.notify.open({
                    view: 'bulk',
                    dayLabel: this.getDate(key),
                    rows: this.calls[key] || [],
                    clicked: type === 'day' ? { type: 'day' } : { type: 'item', index: index },
                });
            },
            onNotified() {
                // notified_at moved on the sent calls — re-read the day so the sheet agrees
                if (typeof this.getBulkCalls === 'function') this.getBulkCalls();
            },
            getClient(){
                service.get('client/' + this.userClientID, {
                    'Authorization': this.userToken
                }).
                then((res) => {
                    this.empSort = res.data.result.default_employee_sort;
                }).catch((err) => {
                    console.log(err);
                });
            },

            getRoundOffSkillSeniority(seniorityVal) {
                if(seniorityVal && seniorityVal != '') {
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },

            addCallPower(){
                if(this.jobEmployeeId==this.employeeId){
                  return true;
                }else{
                  return false;
                }
            },

            getDateScrollTO(str) {
                return moment(str, 'YYYY-MM-DD').format('DD MMM YYYY');
            },

            onSelectScrollTo(e) {
                const firstScrollTo = scroller();
                firstScrollTo(e.target.value, 200, {
                    offset: -100
                });
            },

            addBulkCall(date='') {
                this.$router.push({
					path:'/addCall/'+ this.$route.params.jobId,
                    query: date!=''?{ date: date }: null
				});
            },

            changeSortType() {
                bus.$emit('sortTypeChanged', this.selectedSortType);
            },

            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },

            getCurrencyIcon(){
                let icon='';
                switch(this.getCurrency){
                    case 'usd':
                        icon = '$';
                        break;
                    case 'pound':
                        icon = '&#163;';
                        break;
                    default:
                        icon = '$';
                }
                return icon;
            },

            getCurrencyUpper(){
                return this.getCurrency?this.getCurrency.toUpperCase():'USD';
            },

            getGlobalDate(dateTime) {
                return dateTimeConvert.localDate(dateTime);
            },

            selectAllDay() {
                this.selectedFilterDay = 'allDay';
                let self = this;
                this.avdCloneCall.forEach(function(call) {
                    self.advanceCloneData.selectedDaysToClone.push(call.date);
                });
            },

            deleteCallsByDate(dateWiseCalls){
                let callIds = [];
                dateWiseCalls.forEach(calls =>{
                    if(calls.call){
                        calls.call.forEach(call =>{
                            callIds.push(call.id);
                        })
                    }
                });
                this.$confirm('CALL will be removed from the records of CALL LIST and Confirmed Calls Will Be Notified. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('call/deleteBulkCall', {
                        'callIds': JSON.stringify(callIds),
                        'userId':this.userID,
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                        this.getBulkCalls();
                    }).catch((err) => {
                        this.$notify({
                            type: 'error',
                            message: 'Something Went wrong',
                            title: 'Error'
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },

            selectNoneAllDay() {
                this.selectedFilterDay = 'noneDay';
                this.advanceCloneData.selectedDaysToClone = [];
            },

            selectAllCall() {
                this.selectedFilter = 'all';
                let self = this;
                this.advanceCloneData.callUnderSelectedDay.forEach(function(call) {
                    self.advanceCloneData.selectedcallsToClone.push(call.id);
                });
            },

            selectNoneAllCall() {
                this.selectedFilter = 'none';
                this.advanceCloneData.selectedcallsToClone = [];
            },

            sortCalls() {
                this.calls = []
                this.calls = this.dummyCalls;
                switch (this.selectedSortType) {
                    case 'start':
                        var _vm = this;
                        for (let key in this.calls) {
                            this.calls[key].forEach((item) => {
                                if((item.employee && !item.employee.seniority)||(item.employee && item.employee.seniority == '')) {
                                    item.employee.seniority = 0;
                                }else {
                                    if(item.employee){
                                        item.employee.seniority = parseFloat(item.employee.seniority);
                                    }
                                }
                            });
                        }

                        for (let key in this.calls) {
                            var promises = this.calls[key].map((value) => {
                                if(value.call) {
                                    value.call.sort(function(a, b) {
                                        if(a.employee && b.employee) {
                                            if(a.employee["seniority"] >=0 && b.employee["seniority"] >=0){
                                                if (parseFloat(a.employee.seniority) > parseFloat(b.employee.seniority)) return 1;
                                                if (parseFloat(a.employee.seniority) < parseFloat(b.employee.seniority)) return -1;
                                                if (a.employee.seniority == b.employee.seniority) {
                                                    return _vm.sortByEmpName(a,b);
                                                }
                                            } else {
                                                return -1;
                                            }
                                        }else if(!a.employee) {
                                            return -1;
                                        }else if(!b.employee) {
                                            return 0;
                                        }
                                        return -1;
                                    });
                                }
                            });
                            Promise.all(promises).then(function(results) {
                                if(results) {
                                    _vm.calls[key].sort((a,b) => {
                                         var dateA = moment(a.start);
                                        var dateB = moment(b.start);
                                        return dateA > dateB ? 1 : -1;
                                    });
                                }
                            });
                        }

                        break;
                    case 'status':
                        var _vm = this;
                        for (let key in this.calls) {
                            this.calls[key].forEach((item) => {
                                if((item.employee && !item.employee.seniority)||(item.employee && item.employee.seniority == '')) {
                                    item.employee.seniority = 0;
                                }else {
                                    if(item.employee){
                                        item.employee.seniority = parseFloat(item.employee.seniority);
                                    }
                                }
                            });
                        }
                        for (let key in this.calls) {
                            var promises = this.calls[key].map((value) => {
                                if(value.call) {
                                    value.call.sort(function(a, b) {
                                        if(a.employee && b.employee) {
                                            if(a.employee["seniority"] >=0 && b.employee["seniority"] >=0){
                                                if (parseFloat(a.employee.seniority) > parseFloat(b.employee.seniority)) return 1;
                                                if (parseFloat(a.employee.seniority) < parseFloat(b.employee.seniority)) return -1;
                                                if (a.employee.seniority == b.employee.seniority) {
                                                    return _vm.sortByEmpName(a,b);
                                                }
                                            } else {
                                                return -1;
                                            }
                                        }else if(!a.employee) {
                                            return -1;
                                        }else if(!b.employee) {
                                            return 0;
                                        }
                                        return -1;
                                    });
                                }
                            });
                            Promise.all(promises).then(function(results) {
                                if(results) {
                                    _vm.calls[key].sort((a,b) => {
                                        if (a.unassigned >= b.unassigned) return -1;
                                        if (a.unassigned < b.unassigned) return 1;
                                    });
                                }
                            });
                        }
                        break;
                    case 'skill':
                        var _vm = this;
                        for (let key in this.calls) {
                            this.calls[key].forEach((item) => {
                                if((item.employee && !item.employee.seniority)||(item.employee && item.employee.seniority == '')) {
                                    item.employee.seniority = 0;
                                }else {
                                    if(item.employee){
                                        item.employee.seniority = parseFloat(item.employee.seniority);
                                    }
                                }
                            });
                        }

                        for (let key in this.calls) {
                            var promises = this.calls[key].map((value) => {
                                if(value.call) {
                                    value.call.sort(function(a, b) {
                                        if(a.employee && b.employee) {

                                            if(a.employee["seniority"] >=0 && b.employee["seniority"] >=0){
                                                if (parseFloat(a.employee.seniority) > parseFloat(b.employee.seniority)) return 1;
                                                if (parseFloat(a.employee.seniority) < parseFloat(b.employee.seniority)) return -1;
                                                if (a.employee.seniority == b.employee.seniority) {
                                                    return _vm.sortByEmpName(a,b);
                                                }
                                            } else {
                                                return -1;
                                            }
                                        }else if(!a.employee) {
                                            return -1;
                                        }else if(!b.employee) {
                                            return 0;
                                        }
                                        return -1;
                                    });
                                }
                            });
                            Promise.all(promises).then(function(results) {
                                if(results) {
                                    _vm.calls[key].sort((a,b) => {
                                        if (a.skills[0].priotiy < b.skills[0].priotiy) return -1;
                                        if (a.skills[0].priotiy > b.skills[0].priotiy) return 1;
                                        return 0;
                                    });
                                }
                            });
                        }
                        
                        break;
                    case 'seniority':
                        for (let key in this.calls) {
                            this.calls[key].forEach((item) => {
                                if((item.employee && !item.employee.seniority)||(item.employee && item.employee.seniority == '')) {
                                    item.employee.seniority = 0;
                                }else {
                                    if(item.employee){
                                        item.employee.seniority = parseFloat(item.employee.seniority);
                                    }
                                }
                            });
                        }
                        var _vm = this;
                        for (let key in this.calls) {
                            var promises = this.calls[key].map((value) => {
                                if(value.call) {
                                    value.call.sort(function(a, b) {
                                        if(a.employee && b.employee) {
                                            if(a.employee["seniority"] >=0 && b.employee["seniority"] >=0){
                                                if (parseFloat(a.employee.seniority) > parseFloat(b.employee.seniority)) return 1;
                                                if (parseFloat(a.employee.seniority) < parseFloat(b.employee.seniority)) return -1;
                                                if (a.employee.seniority == b.employee.seniority) {
                                                    if(a.employee.employable && a.employee.employable.last_name && b.employee.employable && b.employee.employable.last_name) {
                                                        var nameA = a.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                                                        var nameB = b.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                                                        if (nameA < nameB) {
                                                            return -1;
                                                        }
                                                        if (nameA > nameB) {
                                                            return 1;
                                                        }
                                                    }
                                                }
                                            } else {
                                                if(a.employee&&a.employee.employable && a.employee.employable.last_name &&b.employee&& b.employee.employable && b.employee.employable.last_name) {
                                                    var nameA = a.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                                                    var nameB = b.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                                                    if (nameA < nameB) {
                                                        return -1;
                                                    }
                                                    if (nameA > nameB) {
                                                        return 1;
                                                    }
                                                }
                                            }
                                        }
                                        return -1;
                                    });
                                }
                            });
                            // var _vm = this;
                            Promise.all(promises).then(function(results) {
                                if(results) {
                                    _vm.calls[key].sort((a,b) => {
                                        if(a.call && a.call.length > 0) {
                                            if(a.call[0].employee && b.call[0].employee) {
                                                if(!a.call[0].employee["seniority"] || a.call[0].employee["seniority"] == '') return 1;
                                                if(!b.call[0].employee["seniority"] || b.call[0].employee["seniority"] == '') return -1;
                                                if(a.call[0].employee["seniority"] && b.call[0].employee["seniority"]){
                                                    if (parseFloat(a.call[0].employee.seniority) > parseFloat(b.call[0].employee.seniority)) return 1;
                                                    if (parseFloat(a.call[0].employee.seniority) < parseFloat(b.call[0].employee.seniority)) return -1;
                                                    if (parseFloat(a.call[0].employee.seniority) == parseFloat(b.call[0].employee.seniority)) {
                                                        return _vm.sortByEmpName(a,b);
                                                    }
                                                    return -1;
                                                } else {
                                                    return -1;
                                                }
                                            }else {
                                                if(!a.call[0].employee) return 1;
                                                if (!b.call[0].employee) return -1;
                                                return -1;
                                            }
                                        }
                                        return 0;
                                    });
                                }
                            });
                        }
                        break;
                    default:
                        console.log("default case..");
                }
            },

            sortByEmpName(a,b) {
                if(this.empSort == 'fname_desc') {
                    if(a.employee&&a.employee.employable && a.employee.employable.last_name && b.employee&&b.employee.employable && b.employee.employable.last_name) {
                        var nameA = a.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                        var nameB = b.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -1;
                        }
                        else {
                            return 1;
                        }
                    }
                } else {
                    if(a.employee&&a.employee.employable && a.employee.employable.first_name && b.employee&&b.employee.employable && b.employee.employable.first_name) {
                        var nameA = a.employee.employable.first_name.toUpperCase(); // ignore upper and lowercase
                        var nameB = b.employee.employable.first_name.toUpperCase(); // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                    }
                }
            },

            extractDateOnly(dateTime) {
                return dateTime.split(" ")[0];
            },

            deleteBulkCall(calls) {
                let self = this;
                let callIds = [];
                calls.call.forEach(function(call) {
                    callIds.push(call.id);
                });
                this.$confirm('CALL will be removed from the records of CALL LIST. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('call/deleteBulkCall', {
                        'callIds': JSON.stringify(callIds),
                        'userId':this.userID,
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                        this.getBulkCalls();
                    }).catch((err) => {
                        // console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },

            closeEditBulk() {
                this.$modal.hide("edit-bulk");
            },

            editBulk(call) {
                this.$modal.show("edit-bulk");
                this.$Progress.start();
                this.isNoteChanged = false;
                service.get('call/callDaysForJob', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'job-id': atob(this.$route.params.jobId),
                    })
                    .then((res) => {
                        this.callDaysForJob = res.data.result;
                        this.$Progress.finish();

                    }).catch((err) => {
                        // console.log(err);
                        this.$Progress.finish();
                    });
                this.getPositions();
                this.editBulkcall.startDate = call.called_at.split(" ")[0];
                this.editBulkcall.startTime = this.getTime(call.start);
                this.editBulkcall.endDate = call.end.split(" ")[0];
                this.editBulkcall.endTime = this.getTime(call.end);
                this.editBulkcall.skill = call.skills[0].id;
                this.editBulkcall.skillName = call.skills[0].name;
                this.editBulkcall.notes=call.notes;
                this.editBulkcall.rate=call.rate;
                let self = this;
                this.callIds = [];
                call.call.forEach(function(singleCall) {
                    self.callIds.push(singleCall.id);
                    if(!self.editBulkcall.notes && singleCall.notes){
                        self.editBulkcall.notes = singleCall.notes;
                    }
                });
                // #2017 — the amount coming in
                this.callsInGroup.floor = this.callIds.length;
                this.callsInGroup.value = this.callIds.length;
            },

            // #2017 — "Calls in group" (shared rules in src/callsInGroup.js)
            stepCallsInGroup(delta) {
                this.callsInGroup.value = clampCallsInGroup(this.callsInGroup.value + delta, this.callsInGroup.floor);
            },
            clampCallsInGroupInput() {
                const v = clampCallsInGroup(this.callsInGroup.value, this.callsInGroup.floor);
                if (Number(this.callsInGroup.value) < this.callsInGroup.floor) {
                    this.$notify({
                        title: 'Calls in group',
                        message: 'The group cannot go below ' + this.callsInGroup.floor + ', its size when this edit was opened. Remove calls with the per-call delete instead.',
                        type: 'warning'
                    });
                }
                this.callsInGroup.value = v;
            },

            async saveEditCall() {
                let formData = {
                keep_confirmation: this.editBulkcall.keep_confirmation,
                end: moment(this.editBulkcall.startDate + " " + this.editBulkcall.endTime, ["YYYY-MM-DD h:mm a"]).format('YYYY-MM-DD HH:mm:ss'),
                start: moment(this.editBulkcall.startDate + " " + this.editBulkcall.startTime, ["YYYY-MM-DD h:mm a"]).format('YYYY-MM-DD HH:mm:ss'),
                skill_id: this.editBulkcall.skill,
                job_id: atob(this.$route.params.jobId),
                called_at: moment(this.editBulkcall.startDate + " " + this.editBulkcall.startTime, ["YYYY-MM-DD h:mm a"]).format('YYYY-MM-DD HH:mm:ss'),
                ids: JSON.stringify(this.callIds),
                start_status: (this.callsFilter.start) ? 1 : 0,
                end_status: (this.callsFilter.end) ? 1 : 0,
                skill_status: (this.callsFilter.position) ? 1 : 0,
                notes: this.editBulkcall.notes,
                rate : this.editBulkcall.rate,
                user_id: this.userID,
                calls_in_group: this.callsInGroup.value   // #2017 — server adds the difference, refuses a shrink
            }
            const addingCalls = callsToAdd(this.callsInGroup.value, this.callsInGroup.floor);
            if (moment(this.editBulkcall.startTime, 'HH:mm A').format('HH:mm:ss')>=moment(this.editBulkcall.endTime, 'HH:mm A').format('HH:mm:ss')) {
                formData.end=moment(formData.end, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').format('YYYY-MM-DD HH:mm:ss');
            }
          
            await service.put('call/group', formData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then(async(res) => {
                    var msg = '';
                    this.$modal.hide("edit-bulk");
                    if(res.data.result.length==0){
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Call Edited Successfully.' + (addingCalls > 0 ? ' ' + addingCalls + ' call' + (addingCalls === 1 ? '' : 's') + ' added to the group.' : ''),
                            type: 'success'
                        });
                        await this.getBulkCalls();
                    }else{
                        msg = 'The call for these employee(s) can`t be updated because of following conflict.\n';
                        let conflicts = '';
                        for(var i=0; i<res.data.result.length; i++){
                            conflicts = conflicts + (i+1)+ '.' + res.data.result[i].emp_name+' - '+res.data.result[i].conflict_type;
                            if(i != res.data.result.length-1) {
                                conflicts = conflicts + ',  \n'
                            }
                        }
                        msg = msg + conflicts;
                        console.log(msg);
                        await this.getBulkCalls();
                        this.$notify({
                            title: this.$t('error'),
                            message: msg,
                            type: 'error'
                        });

                    }
                }).catch((err) => {
                    // console.log('error',err);
                    // #2017 — a refused "Calls in group" (422) carries its reason; show it rather than the generic line
                    const serverMsg = err && err.response && err.response.data && err.response.data.status_message;
                    this.$notify({
                        title: this.$t('error'),
                        message: typeof serverMsg === 'string' && serverMsg ? serverMsg : 'Call cannot be updated because of the conflict.',
                        type: 'error'
                    });
                });
                this.editBulkcall.keep_confirmation = 0;
                this.editBulkcall.keep_notes = 0;
                this.editBulkcall.keep_rates = 0;
            },

            async getPositions() {
                await service.get('skill/getAllSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.positions = res.data.result;
                }).catch((err) => {
                    console.log(err);
                });
            },

            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },

            getDate(dateTime) {
                return dateTimeConvert.localDateFull(dateTime);
            },

            getGlobalDate(dateTime) {
                return dateTimeConvert.localDate(dateTime);
            },

            bulkAssign(call, id) {
                this.$store.dispatch('setBulkCall', call);
                this.$store.dispatch('setLastPositionId', id);
                this.$router.push({
                    path: `/bulkAssignCustom/` + this.$route.params.jobId
                });
            },

            async getBulkCalls() {
                let header = {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'start': (this.callsFilter.start) ? 1 : 0,
                    'end': (this.callsFilter.end) ? 1 : 0,
                    'skill': (this.callsFilter.position) ? 1 : 0
                };
                this.$Progress.start();
                this.afterAPI = false;
                this.calls = [];
                let scrollPositionX = window.pageXOffset;
                let scrollPositionY = window.pageYOffset;
                this.loading = true;
                await service.get('call/' + atob(this.$route.params.jobId) + '/group', header)
                .then(async(res) => {
                    this.loading = false;
                    const ordered = Object.keys(res.data.result).sort().reduce(
                        (obj, key) => {
                            obj[key] = res.data.result[key];
                            return obj;
                        },
                        {}
                    );

                    this.calls = { ...ordered }
                    this.dummyCalls = this.calls;
                    this.$Progress.finish();
                    bus.$emit('onUpdateCallList', this.calls);
                    this.afterAPI = true;
                    await this.sortCalls();
                    if(this.getLastPositionId && this.getLastPositionId !=''){
                        let self=this;
                        setTimeout(() => {
                            var positionID='#'+self.getLastPositionId;
                            const firstScrollTo = scroller();
                            firstScrollTo(positionID, 200, {
                                offset: -150
                            });
                            self.$store.dispatch('setLastPositionId', '');
                        }, 300);
                    }
                    else {
                        window.scrollTo(scrollPositionX, scrollPositionY);
                        document.body.scrollPositionY;
                    }
                    this.initGroupAutofills();
                    this.$nextTick(() => this.updateGroupAutofillsFromIndividuals());

                }).catch((err) => {
                    // console.log(err);
                    this.$Progress.finish();
                    this.loading = false;
                    this.afterAPI = true;
                     if(err.response&&err.response.status&&err.response.status==403) {
                        this.isEmployeeAllowed = false;
                        bus.$emit('onOptionsNotAllowed', this.isEmployeeAllowed);
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                    }
                });
            },

            async refreshBulkCalls() {
                if(this.getSelectedCallList == 'bulk') {
                    this.afterAPI = false;
                    let scrollPositionX = window.pageXOffset;
                    let scrollPositionY = window.pageYOffset;
                    let header = {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'start': (this.callsFilter.start) ? 1 : 0,
                        'end': (this.callsFilter.end) ? 1 : 0,
                        'skill': (this.callsFilter.position) ? 1 : 0
                    };
                    await service.get('call/' + atob(this.$route.params.jobId) + '/group', header)
                    .then(async(res) => {
                        this.calls =[];
                        this.loading=true;
                        setTimeout(() => {
                            this.loading=false;
                        }, 200);
                        this.calls = res.data.result;
                        this.dummyCalls = res.data.result;
                        this.$Progress.finish();
                        bus.$emit('onUpdateCallList', this.calls);
                        this.afterAPI = true;
                        await this.sortCalls();
                        if(this.getLastPositionId && this.getLastPositionId !=''){
                            let self=this;
                            setTimeout(() => {
                                var positionID='#'+self.getLastPositionId;
                                const firstScrollTo = scroller();
                                firstScrollTo(positionID, 200, {
                                    offset: -150
                                });
                                self.$store.dispatch('setLastPositionId', '');
                            }, 300);
                        }
                        else {
                            window.scrollTo(scrollPositionX, scrollPositionY);
                            document.body.scrollPositionY;
                        }
                        this.$forceUpdate();

                    }).catch((err) => {
                        // console.log(err);
                        this.$Progress.finish();
                        this.loading = false;
                        this.afterAPI = true;
                    });

                }
            },

            async onInputchangeCheckbox() {
                await this.getBulkCalls();
            },

            openCloneModal(cloneFrom) {
                this.cloneConflictEmployees = [];
                this.$modal.show("call-clone");
                this.cloneData.cloneFrom = cloneFrom.split(" ")[0];
                this.$Progress.start();
                service.get('call/callDaysForJob', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'job-id': atob(this.$route.params.jobId),
                    })
                    .then((res) => {
                        this.callDaysForJob = res.data.result;
                        this.cloneData.closeTo = this.callDaysForJob[0].date;
                        this.$Progress.finish();
                    }).catch((err) => {
                        // console.log(err);
                        this.$Progress.finish();
                    });
            },

            async cloneCall() {

                let fromData = {
                    from: this.cloneData.cloneFrom + " " + Date().slice(16, 24),
                    to: this.cloneData.closeTo, // + " " + Date().slice(16, 24),
                    job_id: atob(this.$route.params.jobId),
                    assign: (this.cloneData.assignments) ? 1 : 0,
                    user_id: this.userID
                };
                await service.post('call/clone', fromData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then(async(res) => {
                    this.$modal.hide("call-clone");
                    if(res.data.result && res.data.result.length) {
                        this.cloneConflictEmployees = res.data.result;
                        this.$modal.show("clone-conflict-employee-modal");
                    }
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Call Clone Successfully.',
                        type: 'success'
                    });
                    await this.getBulkCalls();
                }).catch((err) => {
                    // console.log(err);
                });
            },

            closeCloneModal() {
                this.$modal.hide("call-clone");
            },

            openAdvanceClone(selectedCloneTo) {
                this.cloneConflictEmployees = [];
                this.$Progress.start();
                this.advanceCloneData.selectedcallsToClone=[];
                service.get('call/callDaysForJob', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'job-id': atob(this.$route.params.jobId),
                    })
                    .then((res) => {
                        this.callDaysForJob = res.data.result;
                        for (let i = 0; i < this.callDaysForJob.length; i++) {
                            if (this.callDaysForJob[i].calls.length > 0) {
                                if (this.callDaysForJob[i].date.split(" ")[0] == selectedCloneTo) {
                                    this.advanceCloneData.callUnderSelectedDay = this.callDaysForJob[i].calls;
                                }
                            }
                        }
                        this.$Progress.finish();
                    }).catch((err) => {
                        // console.log(err);
                        this.$Progress.finish();
                    });

                    //show list of jobs
                    this.$Progress.start();
                    service.get('job/jobsListing', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    })
                    .then((res) => {
                        this.$Progress.finish();
                        this.advanceCloneData.selectedCloneToJob=atob(this.$route.params.jobId);
                        this.getJobCalls();
                        this.avdCloneJob=res.data.result;
                    }).catch((err) => {
                        // console.log(err);
                        this.$Progress.finish();
                    });
                this.$modal.show("advance-call-clone");
            },

            getJobCalls(){
                this.advanceCloneData.selectedDaysToClone=[];
                this.selectedFilterDay = 'noneDay';
                this.$Progress.start();
                    service.get('call/jobCallsListing', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'job-id': this.advanceCloneData.selectedCloneToJob,
                    })
                    .then((res) => {
                        this.$Progress.finish();
                        this.avdCloneCall=res.data.result;
                    }).catch((err) => {
                        // console.log(err);
                        this.$Progress.finish();
                    });
            },

            closeAdvanceClone() {
                this.$modal.hide("advance-call-clone");
            },

            saveAdvanceClone() {
                let fromData = {
                    call_ids: JSON.stringify(this.advanceCloneData.selectedcallsToClone),
                    clone_to_dates: JSON.stringify(this.advanceCloneData.selectedDaysToClone),
                    insert_mode: this.advanceCloneData.insertMode,
                    assign: this.advanceCloneData.assignments,
                    job_id: this.advanceCloneData.selectedCloneToJob, //atob(this.$route.params.jobId),
                    user_id: this.userID
                };
                service.post('call/advanceCall', fromData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).then((res) => {
                    if(res.data.result && res.data.result.length) {
                        this.cloneConflictEmployees = res.data.result;
                        this.cloneConflictEmployees.forEach((obj) => {
                            obj.conflict_type = obj.conflict_type=='RU' ? 'Recurring Unavailability'
                                                : obj.conflict_type=='booking' && obj.job_no!="" ? 'Booking'
                                                : (obj.conflict_type=='booking' && obj.job_no == "") || (obj.conflict_type=='vacation') ? 'Vacation'
                                                : obj.conflict_type;
                            obj.date = moment(this.cloneData.closeTo).format('MM/DD/YYYY')
                        });
                        this.$modal.show("clone-conflict-employee-modal");
                    }
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Call Clone Successfully.',
                        type: 'success'
                    });
                    this.getBulkCalls();
                    this.$modal.hide("advance-call-clone");
                }).catch((err) => {
                    // console.log(err);
                });
            },

            goToViewEmployee(group) {
                this.$modal.show("viewEmployee");
                this.viewEmpList = group.call;
            },

            noteBtnActive(group){
                let flag = false;
                group.call.forEach(item =>{
                    if(item.notes){
                        flag = true;
                        return false;
                    }
                })
                return flag;
            },

            closeViewEmployee() {
                this.$modal.hide("viewEmployee");
            },

            clearAssign(empList) {
                service.del('call/' + empList.id + '/assign', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'userId': this.userID,
                }).
                then((res) => {
                    this.$modal.hide("viewEmployee");
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Call cleared successfully.',
                        type: 'success'
                    });
                    this.getBulkCalls();
                }).catch((err) => {
                    // console.log(err);
                });
            },

            pollData () {
                this.polling = setInterval(() => {
                    if(document.visibilityState === 'visible'){
                        this.timerState = "Started"
                    }else {
                        this.timerState = "Paused"
                    }
                    if (this.timerState === "Started") {
                        this.refreshBulkCalls();
                    }
                }, 60000);
            },

            closeCloneConflictEmployeeModal() {
                this.$modal.hide("clone-conflict-employee-modal");
                this.cloneConflictEmployees = [];
            },

            copyText(){
                let data1 = [];

                this.cloneConflictEmployees.forEach((obj) => {
                    let tempObj = {
                        'Name': obj.emp_name,
                        'Date': obj.date,
                        'Conflict': obj.conflict_type,
                        'Job Name': obj.job_title,
                        'Job Number': obj.job_no
                    }
                    data1.push(tempObj);
                })

                const items = data1;
                const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
                const header = Object.keys(items[0]);
                const csv = [
                header.join(','), // header row first
                ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
                ].join('\r\n');

                console.log(csv);
                var textarea = document.createElement("textarea");
		        textarea.textContent = csv;
		        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
		        document.body.appendChild(textarea);
		        textarea.select();
		        try {
		            document.execCommand("copy");  // Security exception may be thrown by some browsers.
		            this.$notify({
                        title: 'Success',
                        message: 'Copied to clipboard.',
                        type: 'success'
                    });

		        } catch (ex) {
		            console.warn("Copy to clipboard failed.", ex);
		            return false;
		        } finally {
		            document.body.removeChild(textarea);
		        }
            },
            handleCsvSuccess(msg) {
                // console.log(msg);
            },

            initGroupAutofills() {
                Object.keys(this.calls || {}).forEach(key => {
                this.$set(this.groupAutofills, key, false);
                });
                this.updateGroupAutofillsFromIndividuals();
            },

            updateGroupAutofillsFromIndividuals() {
                Object.keys(this.calls || {}).forEach(key => {
                const dateWiseCalls = this.calls[key] || [];
                let allChecked = true;
                let totalCalls = 0;

                dateWiseCalls.forEach(group => {
                    if (group.call && Array.isArray(group.call)) {
                    group.call.forEach(single => {
                        totalCalls++;
                        if (!single.af) allChecked = false;
                    });
                    }
                });

                this.$set(this.groupAutofills, key, totalCalls > 0 && allChecked);
                });
            },

            async handleGroupChange(key, checked) {
                this.$set(this.groupAutofills, key, checked);
                
                const dateWiseCalls = this.calls[key] || [];
                const payload = [];

                dateWiseCalls.forEach(group => {
                    if (group.call && Array.isArray(group.call)) {
                        group.call.forEach(single => {
                            single.af = checked;
                            payload.push({call_id:single.id, status: single.af});
                        });
                    }
                });
                // console.log(payload);
            
                if (payload.length > 0) {
                    try {
                        await service.post('/call/autofillselections', payload, {
                            Authorization: this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        });
                        this.$notify({ 
                            type: 'success', 
                            message: `Group autofill ${checked ? 'enabled' : 'disabled'} for ${payload.length} calls.` 
                        });
                    } catch (err) {
                    console.error('Group autofill failed:', err);
                    this.$notify({ type: 'error', message: 'Group update failed.' });
                    
                    // Revert on error
                    dateWiseCalls.forEach(group => {
                        if (group.call) {
                            group.call.forEach(single => single.af = !checked);
                        }
                    });
                    this.$set(this.groupAutofills, key, !checked);
                    }
                }
            },
            

            async handleIndividualChange(event, dateKey, group, id) {
                const checked = event.target.checked;
                const payload = [];
                
                if (group.call && Array.isArray(group.call)) {
                    group.call.forEach(singleCall => {
                        singleCall.af = checked; 
                        payload.push({ call_id:singleCall.id, status: singleCall.af });
                    });
                }

                // console.log(payload);

                if (payload.length === 0) return;

                try {
                    await service.post('/call/autofillselections', payload, {
                        Authorization: this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    });
                    
                    this.$notify({ type: 'success', message: `Individual autofill updated.` });
                    
                    this.updateGroupAutofillsFromIndividuals();
                
                } catch (err) {
                    console.error('Individual autofill failed:', err);
                    this.$notify({ type: 'error', message: 'Individual update failed.' });
                    // Revert all calls in the group
                    if (group.call && Array.isArray(group.call)) {
                        group.call.forEach(singleCall => singleCall.af = !checked);
                    }
                    this.updateGroupAutofillsFromIndividuals();
                }
            }
        },

        components: {
            VueJsonToCsv,
            NotAllowed,
            CallSheetNotify
        },

        mounted() {
            this.selectedJobTitle = this.job?this.job.title:'';
            $(this.$el).find('input').datetimepicker(this.config)
                .on('dp.show', (e) => {
                    const picker = e.target; // Reference to the picker element
                    const currentTime = moment();
                    if (!picker.value) {
                        $(picker).data('DateTimePicker').date(currentTime);
                    }
                });
        },

        created() {

            // #1854 — get a jump on the assign caches for this job. Fires in the

            // background and is never awaited, so it cannot delay this page.

            try {

                warmJobCache(atob(this.$route.params.jobId), {

                    'Authorization': this.userToken,

                    'cs3-context-role': this.userRole,

                    'cs3-context-clientId': this.userClientID,

                });

            } catch (e) { /* never blocks the page */ }

            bus.$emit('onOptionsNotAllowed', this.isEmployeeAllowed);
            this.getBulkCalls();
            this.getClient();
            this.selectedSortType=this.sortType ? this.sortType: 'start';
            bus.$on('onSaveNewCall', (data) => {
                this.getBulkCalls();
            });
            this.pollData();
        },

        beforeDestroy () {
            clearInterval(this.polling)
        }
    }
</script>
<style scoped>

/* #2017 — the "Calls in group" stepper */
.cig { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; }
.cig__btn { min-width: 34px; line-height: 1.2; }
.cig__input { width: 80px; text-align: center; display: inline-block; }
.cig__hint { flex-basis: 100%; color: #888; }
.mt-5px {
    margin-top: 5px!important;
}
.mr-5px {
    margin-right: 5px!important;
}
.allign-right{
    text-align: right;
}
.unassigned-calls-number {
    background-color: #FB8B03;
    padding-left: 2px;
    padding-right: 2px;
}
.float-right {
    float: right;
}
.view-bulk-call-list-scroll{}
.view-bulk-call-list-scroll > div{
    font-size: 12px;
}
.confirm-check-icon-style{
    background-color: green;
    border-radius: 100%;
    color: white;
    padding: 2px;
}
.clone-to-select-box{
    display: inline-block;
    width: 70%;
}
.clone-to-box-inline{
    display: inline-block;
    width: 65%;
}
.text-danger{
    color: red !important;
}
</style>
